export default "__VITE_ASSET__DRfjtMoy__"